module.exports = __webpack_public_path__ + "img/image00007-min.45a34b25.jpeg";